import React, { useEffect, useState } from "react"

import { MainNavProps } from "../navigation/main/MainParamList"
import { Str_Account, Str_Contacts, Str_Nick, } from "../../language/string_res"
import { color_333333, color_999999, white } from "../../assets/style/colors"
import { Pressable, SectionList, StyleSheet, } from "react-native"
import { useStore } from "../../store/UserStore"
import { User } from "../../../imsdk/db/t_user";
import { getUserName, useNavigationToChatView2 } from "./chat-helper"
import { LeftView } from "./CListItem"
import { Avatar } from "../../../imsdk/api/topic"
import { toSingleChat } from "../Contact/CreateChat"
import { useIsFocused } from "@react-navigation/native"
import { ListEmpty } from "../../components/ListEmpty"
import { CommonText, Div, SectionHeader } from "./ChatSearch"
import { ScreenCloseModal } from "../../components/ScreenModal"
import { ChatSearchInput } from "./components/ChatSearchInput"

type ChatSearchData = {
    title: string;
    data: any[];
};
let searchTimer: any = null
export const MoreChatContactSearch = ({ navigation, route }: MainNavProps<'MoreChatContactSearch'>) => {
    const { curSearch, data } = route.params
    const [searchText, setSearchText] = useState(curSearch)
    const [section, setSection] = useState<ChatSearchData[]>([]);
    const { state } = useStore();
    const toChatView = useNavigationToChatView2();
    const isFocused = useIsFocused()
    useEffect(() => {
        if (isFocused && data && data.length > 0) {
            setSection([{
                title: Str_Contacts,
                data: data
            }])
        }
    }, [isFocused, data])
    const onChangeText = (text: string) => {
        // 清除之前的定时器（如果有）  
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        setSearchText(text)
        // 设置新的定时器  
        searchTimer = setTimeout(() => {
            // 定时器到期，执行搜索  
            startSearch(text)
            // 这里可以替换为实际的搜索逻辑  
        }, 500);
    }
    const startSearch = (text: string) => {
        const sections: ChatSearchData[] = []
        if (text.length === 0) {
            setSection(sections)
            return
        }
        function contactsFilterDeleted() {
            const c = state?.contactList ?? []
            const result: User[] = []
            c.forEach((value) => {
                const b1 = value.status !== 'deleted'
                if (b1) {
                    result.push(value)
                }
            })

            return result
        }
        const doSearch = async () => {
            const filterUser = contactsFilterDeleted();
            let data: { data: any, subText: string }[] = [];
            if (text && text.length > 0) {
                const n = filterUser.length
                for (let i = 0; i < n; i++) {
                    const user = filterUser[i]
                    if (user.remark && user.remark.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: '' })
                        continue
                    }
                    if (user.nick && user.nick.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: `${Str_Nick}：${user.nick}` })
                        continue
                    }
                    if (user.email && user.email.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: `${Str_Account}：${user.email}` })
                        continue
                    }
                    if (user.telno && user.telno.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: `${Str_Account}：${user.telno}` })
                        continue
                    }
                }
            }
            const length = data.length
            if (data.length > 0) {
                const item = {
                    title: Str_Contacts,
                    data: data
                }
                sections.push(item)
                setSection(sections)
            } else {
                setSection([])
            }
        };
        doSearch()
    }

    const RenderItem = ({ item }: { item: { subText: string, data: any } }) => {
        const user = item.data as User
        const name = getUserName(user)
        const left: Avatar = { avatar: user?.avatar, name: name, uid: user?.uid || 0 };
        return (<Pressable
            onPress={() => {
                toSingleChat(user.uid, toChatView)
                navigation.goBack()
            }}
            style={styles.userContainer} >
            <LeftView left={left} />
            {CommonText(name, item.subText)}
        </Pressable>)
    }

    return (<ScreenCloseModal>
        <ChatSearchInput searchText={searchText} onChangeText={onChangeText} />
        <SectionList
            sections={section}
            keyExtractor={(item, index) => index.toString()}
            renderItem={RenderItem}
            ItemSeparatorComponent={Div}
            ListEmptyComponent={() => {
                if (searchText && searchText.length > 0) {
                    return (<ListEmpty />)
                }
                return null
            }}
            renderSectionHeader={({ section }) => (<SectionHeader title={section.title} />)} />
    </ScreenCloseModal>)
}
const styles = StyleSheet.create({
    header: {
        fontSize: 13,
        marginStart: 16,
        paddingVertical: 8,
        color: "#737373"
    },
    userContainer: {
        flexDirection: "row",
        backgroundColor: white,
        paddingVertical: 8,
        paddingHorizontal: 12,
        alignItems: "center",
    },
    userTitle: {
        color: color_333333,
        fontSize: 14,
        width: '100%',
        fontWeight: 'bold',
        fontFamily: '',
    },
    subUserTitle: {
        color: color_999999,
        width: '100%',
        fontSize: 12,
    },
})